import { useUser } from "../contexts/UserContext";

/**
 * Logic for checking user permissions, to determine if components should be displayed
 * 
 * @returns {Function} hasPermission - returns boolean, checks if user has permissions to perform an action (create, read, etc) on a specific resource (agms, pois, etc)
 * @returns {Function} isInGroup - returns boolean, checks if user is in specific group
 * 
 * @category Hooks
*/
const usePermissions = () => {
    const { userPermissions, userGroups } = useUser();

    const hasPermission = (resource, action) => {
        if(!userPermissions) return false
        
        if (action) {
            return userPermissions[resource] && userPermissions[resource][action];
        } else {
            return userPermissions.hasOwnProperty(resource);
        }
    };

    const isInGroup = (groups) => {
        // Support both single group (string) and multiple groups (array)
        // Returns true if user is in ANY of the required groups (OR logic)
        const requiredGroups = Array.isArray(groups) ? groups : [groups];
        return requiredGroups.some(group => userGroups.includes(group));
    };

    const isExternal = () => {
        return userGroups.length === 1 && userGroups[0] === "External";
    };    

    return { hasPermission, isInGroup, isExternal };
};

export default usePermissions;
